import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// Zichtbaar wanneer de gebruiker vanuit Vraag & antwoord is doorgeklikt (route-state van: "vraag").
// Terug navigeren herstelt de bewaarde vraag/antwoord-status (sessieopslag in VraagAntwoord).
// onderaan=true: tweede exemplaar onderaan de pagina (geen scroll-naar-boven effect).
export const TerugNaarVraag = ({ onderaan = false }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const vanVraag = location.state?.van === "vraag";
  useEffect(() => {
    if (vanVraag && !onderaan) window.scrollTo({ top: 0 });
  }, [vanVraag, onderaan]);
  if (!vanVraag) return null;
  return (
    <button data-testid={onderaan ? "terug-naar-vraag-btn-onder" : "terug-naar-vraag-btn"}
      onClick={() => navigate("/")}
      className={`${onderaan ? "mt-2" : "mb-4"} inline-flex items-center gap-2 text-sm font-medium text-[#8a5a20] bg-white border border-[#E4D3B8] rounded-full px-4 py-2 hover:bg-[#FBF3E3] transition-colors shadow-sm`}>
      <ArrowLeft className="w-4 h-4 text-[#B9772B]" /> Terug naar mijn vraag
    </button>
  );
};
